var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"name":_vm.name}},[_c('svgicon',{class:_vm.direction,attrs:{"name":"arrow"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }